import React, { useEffect } from 'react';

import { useNavigate } from 'react-router-dom';

// UI Components
import Typography from '../GenericUIBlocks/Typography';

// images
//@ts-ignore
import Prebuilt from '../../assets/images/create-template/prebuilt.svg';
//@ts-ignore
import Scratch from '../../assets/images/create-template/scratch.svg';
//@ts-ignore
import HireDesigner from '../../assets/images/create-template/hire-designer.svg';

// styles
import './styles.scss';

const textStyles = {
  fontSize: '20px',
  fontWeight: '600',
  color: '#000000',
  marginBottom: '12px',
  lineHeight: '24px',
};

const descriptionStyles = {
  fontSize: '16px',
  fontWeight: '400',
  color: '#898989',
  width: '100%',
  maxWidth: '254px',
  margin: '0 auto',
  lineHeight: '20px',
  textAlign: 'center' as const,
};

const buttonStyles = {
  width: '100%',
  maxWidth: '157px',
  height: '50px',
  borderRadius: '8px',
  fontSize: '16px',
  fontWeight: '600',
};

interface TemplateTypesProps {
  onReturnAndNavigate?: () => void;
  onHireDesignerNavigate?: () => void;
  showHireDesignerOption?: boolean;
  createTemplateRoute?: string | null;
  selectedTemplateType?: string | null;
  setSelectedTemplateType?: any;
  setTemplateTypeSelected?: any;
}

const TemplateTypes: React.FC<TemplateTypesProps> = ({
  selectedTemplateType,
  setSelectedTemplateType,
  createTemplateRoute,
  setTemplateTypeSelected,
  onReturnAndNavigate,
  onHireDesignerNavigate,
  showHireDesignerOption = false,
}) => {

  const navigate = useNavigate();

  useEffect(() => {
    if (!showHireDesignerOption && selectedTemplateType === 'hire-designer') {
      setSelectedTemplateType?.(null);
    }
  }, [selectedTemplateType, setSelectedTemplateType, showHireDesignerOption]);

  const handleCardClick = (card: string) => {
    if (card === 'hire-designer' && !showHireDesignerOption) {
      return;
    }

    setSelectedTemplateType?.(card);
  };

  const handleNextClick = () => {
    if (selectedTemplateType === 'hire-designer') {
      if (showHireDesignerOption) {
        onHireDesignerNavigate ? onHireDesignerNavigate() : navigate('/hire-a-designer');
      }
      return;
    }

    setTemplateTypeSelected?.(true);
  };

  const isNextDisabled =
    !selectedTemplateType ||
    (!showHireDesignerOption && selectedTemplateType === 'hire-designer');

  return (
    <div className="create-template-new">
      <Typography style={textStyles}>Create New Template</Typography>
      <div className={`cards-container ${showHireDesignerOption ? 'with-hire-designer' : ''}`}>
        <div
          className={`card ${selectedTemplateType === 'prebuilt' ? 'active' : ''}`}
          onClick={() => handleCardClick('prebuilt')}
        >
          <img src={Prebuilt} alt="Prebuilt" />
          <Typography style={textStyles}>Start From Prebuilt</Typography>
          <Typography style={descriptionStyles}>
            Browse a gallery of predesigned templates to customize
          </Typography>
        </div>
        <div
          className={`card ${selectedTemplateType === 'scratch' ? 'active' : ''}`}
          onClick={() => handleCardClick('scratch')}
        >
          <img src={Scratch} alt="Scratch" />
          <Typography style={textStyles}>Build from Scratch</Typography>
          <Typography style={descriptionStyles}>
            Choose a product type
            <br />
            and start with a blank canvas
          </Typography>
        </div>
        {showHireDesignerOption && (
          <div
            className={`card ${selectedTemplateType === 'hire-designer' ? 'active' : ''}`}
            onClick={() => handleCardClick('hire-designer')}
          >
            <img src={HireDesigner} alt="Hire a Designer" />
            <Typography style={textStyles}>Hire a Designer</Typography>
            <Typography style={descriptionStyles}>
              Pay to have a custom template created for you.
            </Typography>
          </div>
        )}
      </div>
      <div className="buttons-container">
        <button disabled={isNextDisabled} onClick={handleNextClick}>Next</button>
        <button
          onClick={() =>
            onReturnAndNavigate
              ? onReturnAndNavigate()
              : navigate(createTemplateRoute || '/create-template')
          }
        >
          Cancel
        </button>
      </div>
    </div>
  );
};

export default TemplateTypes;
